<template>
<!-- <div v-if="!li" class="join-banner">
    <div class="alert mb-5" :class="'alert-primary-' + theme + ' border-primary-' + theme" role="alert">
        <div class="join-banner-body">
            <h4 class="alert-heading display-3">JOIN P&P 4 FREE</h4>
            <p class="fw-bold">Join Pin & Pop today and build your pin collection online with other disney pin traders.</p>
            <p><a href="/register" class="btn btn-dark btn-lg">JOIN NOW</a></p>
        </div>
        <div class="join-banner-bg"></div>
    </div>
</div> -->
<!-- <div v-else-if="new Date().getTime() < new Date('2024-08-01 00:00:00').getTime()" class="join-banner">
    <div class="alert mb-5" :class="'alert-primary-' + theme + ' border-primary-' + theme" role="alert">
        <div class="join-banner-body">
            <h4 class="alert-heading display-3">Christmas in July Specials</h4>
            <p class="fw-bold fs-4">Beat the heat with cool savings!</p>
            <p class="fw-bold">This summer, join the fun with discounts on Trade Tokens and a VIP Membership Bundle to dip your toe in the Trading Pool!</p>
            <p><a href="/store/buy-tokens" class="btn btn-dark btn-lg">View July Specials</a></p>
        </div>
        <div class="join-banner-bg"></div>
    </div>
</div> -->

<!-- <div class="join-banner">
    <div class="alert mb-5" :class="'alert-primary-' + theme + ' border-primary-' + theme" role="alert">
        <div class="join-banner-body">
            <h4 class="alert-heading display-3">Summer Token Specials</h4>
            <p class="fw-bold fs-4">This weekend only!</p>
            <p class="fw-bold">This summer, join the fun with deep discounts on Trade Tokens to dip your toe in the Trading pool!</p>
            <p><a href="/store/buy-tokens" class="btn btn-dark btn-lg">View Specials</a></p>
        </div>
        <div class="join-banner-bg"></div>
    </div>
</div> -->

<!-- <div v-if="new Date().getTime() < new Date('2024-09-29 18:00:00').getTime()" class="text-center mb-5">
    <a href="/events/happy-haunts/2024"><img src="https://home-underground.nyc3.cdn.digitaloceanspaces.com/trade-arcade/happy-haunts-2024/happy-haunts-2024-banner.jpg" class="img-fluid" alt="Don't Miss Happy Haunts 2024"></a>
</div> -->

</template>

<script>
export default {
    name: "PinsAd",
    props: {
        li: {
            type: Boolean,
            default: false
        }
    },
    data () {
        return {
            // theme: localStorage.theme ?? 1
            theme: (localStorage.theme !== null && localStorage.theme !== undefined) ? localStorage.theme : 1
        }
    }
}
</script>